import { useEffect } from "react";

export function usePageMeta(title, description) {
  useEffect(() => {
    document.title = title ? `${title} | ZOHFRY` : "ZOHFRY — हर Student की Problem का Solution";
    if (description) document.querySelector('meta[name="description"]')?.setAttribute("content", description);
  }, [title, description]);
}
